import { Box } from "@mui/material";
import { headerHeight } from "../Header/utils";
import type { PageContainerProps } from "./types/PageContainerProps";

export function PageContainer({ children }: PageContainerProps) {
  return <Box sx={{ marginTop: headerHeight }}>{children}</Box>;
}
